/* Find a Dealer lead form. One question per screen:
     zip -> [beat: map flies to the ZIP] -> name (with the coverage result) -> address
       -> [beat] -> phone -> [beat] -> success
   The map is driven through window.__penguinAreaMap (assets/penguin-area-map.js).
   window.__lead = { state, step(), show(name), sent } drives and inspects it from a console.
   Add ?fd_debug=1 to the URL to log each payload to the console.

   On the phone+email step the lead is posted to the HubSpot form the old penguinwater.com
   Get a Quote / Find a Dealer page embeds (portal 8039080, form c434b24e-…), through the
   Forms API, so it lands in HubSpot exactly like a fill of that form. toHubSpotFields()
   holds the mapping. https://api.hsforms.com is allowed in connect-src in the CSP meta
   tag in templates/page.find-dealer.liquid; the request is blocked without it.
   window.__lead.sent records every body posted (or attempted). ?fd_dry_run=1 builds and
   records the body without posting it, for testing without creating a HubSpot lead. */
const HUBSPOT_PORTAL = '8039080';
const HUBSPOT_FORM = 'c434b24e-0b07-4d94-a792-cdf174d6f071';
const ENDPOINT = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL}/${HUBSPOT_FORM}`;
const LEAD_EMAIL = 'info@penguinwater.com';  // shown when HubSpot can't be reached
const ADDRESS_BEAT_MS = 2850;  // total length of the loading beat after the address step

const form = document.querySelector('[data-fd-form]');
if (form) init(form);

function init(form) {
  const card = form.closest('.fd-card');
  const $ = s => card.querySelector(s);
  const step = name => form.querySelector(`[data-step="${name}"]`);
  const field = name => form.elements[name];
  const debug = new URLSearchParams(location.search).has('fd_debug');
  const dryRun = new URLSearchParams(location.search).has('fd_dry_run');
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wait = ms => new Promise(r => setTimeout(r, ms));

  const lead = {};           // every answer, typed and derived
  const sent = [];           // every HubSpot body send() posted or tried to
  let current = 'zip';
  let coverage = null;       // result of the ZIP lookup
  let unmappedZip = null;    // a well-formed ZIP the map does not know, awaiting "continue anyway"
  let lastAnswered = 'zip';  // while a beat plays, the progress bar stays on the step just answered

  const order = ['zip', 'name', 'address', 'phone'];
  const backMap = { name: 'zip', address: 'name', phone: 'address' };

  // The map module loads its data asynchronously; the form must still work if it never does.
  const mapReady = new Promise(resolve => {
    if (window.__penguinAreaMap) return resolve(window.__penguinAreaMap);
    document.addEventListener('pdam:ready', () => resolve(window.__penguinAreaMap), { once: true });
    setTimeout(() => resolve(window.__penguinAreaMap || null), 10000);
  });

  function setProgress(name) {
    const i = order.indexOf(name);
    const label = $('[data-fd-progress-label]'), bar = $('.fd-progress__track'), fill = $('.fd-progress__fill');
    if (name === 'success') {
      label.textContent = 'Done'; fill.style.width = '100%';
      bar.setAttribute('aria-valuenow', '4'); bar.setAttribute('aria-valuetext', 'Complete');
    } else if (i >= 0) {
      // Never empty on step 1: each step shows the bar partly filled for the step you are on.
      label.textContent = name === 'phone' ? 'Last step' : `Step ${i + 1} of 4`;
      fill.style.width = `${Math.round(((i + 0.5) / 4) * 100)}%`;
      bar.setAttribute('aria-valuenow', String(i + 1)); bar.setAttribute('aria-valuetext', `Step ${i + 1} of 4`);
    }
    const back = $('[data-fd-back]');
    back.hidden = !backMap[name];
  }

  function showStep(name, { focus = true } = {}) {
    current = name;
    form.querySelectorAll('.fd-step').forEach(s => { s.hidden = s.dataset.step !== name; });
    card.dataset.fdCurrent = name;
    setProgress(name);
    if (!focus) return;
    const target = step(name).querySelector('.fd-input') || step(name).querySelector('.fd-question');
    if (target) target.focus({ preventScroll: true });
    // Keep the top of the card in view when the step changes (matters on phones).
    const top = card.getBoundingClientRect().top;
    const header = document.querySelector('.site-header');
    const offset = header && getComputedStyle(header).position === 'sticky' ? header.getBoundingClientRect().height : 0;
    if (top < offset || top > innerHeight * 0.6) card.scrollIntoView({ behavior: reduceMotion() ? 'instant' : 'smooth', block: 'start' });
  }

  function setError(name, message) {
    const input = field(name);
    const error = card.querySelector(`#${input.id}-error`);
    error.textContent = message || '';
    if (message) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    else input.removeAttribute('aria-invalid');
    return !message;
  }

  // Loading beat: 2-3 status lines that name the real work, ~850ms apart by default.
  // Reduced motion shows only the final line and moves on.
  async function playLoading(lines, during, interval = 850) {
    const list = $('[data-fd-lines]');
    list.replaceChildren();
    showStep('loading', { focus: false });
    setProgress(lastAnswered);
    $('[data-fd-back]').hidden = true;
    if (reduceMotion()) {
      const li = document.createElement('li'); li.textContent = lines[lines.length - 1]; list.append(li);
      during && during();
      await wait(350);
      return;
    }
    for (let i = 0; i < lines.length; i++) {
      list.querySelectorAll('li').forEach(li => li.classList.add('is-done'));
      const li = document.createElement('li'); li.textContent = lines[i]; list.append(li);
      if (i === 0 && during) during();
      await wait(interval);
    }
  }

  const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

  function fillHidden() {
    const set = (key, value) => { const el = form.querySelector(`[data-fd-hidden="${key}"]`); el.value = value == null ? '' : String(value); lead[key] = el.value; };
    set('coverage_status', coverage ? coverage.status : '');
    set('dealer_areas_within_30mi', coverage && coverage.count != null ? coverage.count : '');
    set('nearest_dealer_miles', coverage && coverage.nearestMiles != null ? coverage.nearestMiles : '');
    set('nearby_area_ids', coverage && coverage.nearIds ? coverage.nearIds.join(' ') : '');
    set('map_region', coverage && coverage.region ? coverage.region : '');
  }

  // The HubSpot form has no address or coverage fields, and its required "message"
  // field ("Briefly tell us what products you are interested in.") is not asked here,
  // so the message carries the request: street address plus what the ZIP lookup found.
  function leadMessage(p) {
    const status = p.coverage_status;
    const n = Number(p.dealer_areas_within_30mi), miles = p.nearest_dealer_miles;
    const coverage = status === 'covered'
      ? `Covered: ${plural(n, 'Penguin dealer area', 'Penguin dealer areas')} within 30 miles of ZIP ${p.zip}; nearest about ${plural(Number(miles), 'mile', 'miles')}.`
      : status === 'none'
        ? `No dealer area within 30 miles of ZIP ${p.zip}${miles ? `; nearest about ${plural(Number(miles), 'mile', 'miles')}` : ''}. Ask the nearest dealer whether they travel.`
        : `ZIP ${p.zip} could not be placed on the dealer map (${status || 'unknown'}). Check coverage by hand.`;
    return [
      'Find a Dealer request from the new Penguin site: connect me with a local dealer.',
      `Install address: ${p.address}, ${p.zip}`,
      coverage
    ].join('\n');
  }

  // Names and values are the HubSpot form's internal property names; see REPORT.md in
  // projects/penguin-find-dealer-hubspot for the definition they were checked against.
  function toHubSpotFields(p) {
    return [
      { name: 'firstname', value: p.first_name },
      { name: 'email', value: p.email },
      { name: 'phone', value: p.phone },
      { name: 'shipping_postal_code', value: p.zip },
      { name: 'message', value: leadMessage(p) }
    ];
  }

  function cookie(name) {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : undefined;
  }

  function toEndpointBody(payload) {
    const context = { pageUri: location.href, pageName: document.title };
    const hutk = cookie('hubspotutk');  // set by the HubSpot tracker on the site's other pages
    if (hutk) context.hutk = hutk;
    return { fields: toHubSpotFields(payload), context };
  }

  // One post, on the last step: the HubSpot form requires email and phone, so a partial
  // record after the address step would be rejected.
  // Resolves { ok } or { ok: false, field, message } for a value HubSpot refused.
  async function send() {
    fillHidden();
    form.querySelector('[data-fd-hidden="submission_stage"]').value = 'complete';
    const body = toEndpointBody(Object.fromEntries(new FormData(form)));
    sent.push(body);
    if (debug) console.info('[find-dealer] HubSpot body', body);
    if (dryRun) return { ok: true, dryRun: true };
    try {
      const r = await fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (r.ok) return { ok: true, status: r.status };
      const detail = await r.json().catch(() => ({}));
      const errors = (detail && detail.errors) || [];
      console.error('[find-dealer] HubSpot refused the submission', r.status, errors);
      if (errors.some(e => /EMAIL/.test(e.errorType || ''))) return { ok: false, field: 'email', message: 'HubSpot didn’t accept that email address. Please check it.' };
      return { ok: false, status: r.status };
    } catch (error) {
      console.error('[find-dealer] HubSpot submit failed', error);
      return { ok: false };
    }
  }

  // The lead must not vanish: say plainly it wasn't sent, keep every answer, and offer
  // an email with the request already written.
  function showSendFailed(body) {
    const box = $('[data-fd-send-failed]');
    const v = name => (body.fields.find(f => f.name === name) || {}).value || '';
    const text = `Name: ${v('firstname')}\nPhone: ${v('phone')}\nEmail: ${v('email')}\n${v('message')}`;
    $('[data-fd-mailto]').href = `mailto:${LEAD_EMAIL}?subject=${encodeURIComponent('Find a Dealer request')}&body=${encodeURIComponent(text)}`;
    box.hidden = false;
    $('[data-fd-final-label]').textContent = 'Try again';
  }

  function renderResult() {
    const box = $('[data-fd-result]');
    const q = $('[data-fd-name-question]'), why = $('[data-fd-name-why]');
    const aq = $('[data-fd-address-question]'), awhy = $('[data-fd-address-why]');
    const zip = lead.zip;
    box.className = 'fd-result';
    let html;
    if (coverage && coverage.status === 'covered') {
      box.classList.add('fd-result--good');
      const nearest = coverage.nearestMiles < 2 ? 'Your closest dealer is based right in your ZIP area.' : `Your closest dealer is about ${plural(coverage.nearestMiles, 'mile', 'miles')} away.`;
      html = `<span class="fd-result__num">${coverage.count}</span><span class="fd-result__text"><strong>${coverage.count === 1 ? 'Penguin dealer area covers' : 'Penguin dealer areas cover'} ${zip}</strong>${nearest}</span>`;
      q.textContent = 'Great news. Who should they ask for?';
      why.textContent = 'Your dealer asks for you by name when they call. No scripts, no call centre.';
      aq.textContent = 'Let’s confirm the exact service area is covered.';
      awhy.textContent = 'Service areas follow real roads and towns, not circles on a map. Your dealer checks your street before they call.';
    } else if (coverage && coverage.status === 'none') {
      box.classList.add('fd-result--none');
      const nearest = coverage.nearestMiles != null ? `The closest Penguin dealer is about ${plural(coverage.nearestMiles, 'mile', 'miles')} away.` : '';
      html = `<span class="fd-result__icon" aria-hidden="true">!</span><span class="fd-result__text"><strong>No dealer covers ${zip} yet.</strong>${nearest}</span>`;
      q.textContent = 'We can still help. Who should we follow up with?';
      why.textContent = 'We’ll ask the closest dealer whether they travel to you, and tell you as soon as someone covers your area.';
      aq.textContent = 'Where would the system be installed?';
      awhy.textContent = 'Some dealers travel beyond their usual area. Your address tells them exactly how far.';
    } else {
      box.classList.add('fd-result--none');
      const why0 = coverage && coverage.status === 'outside' ? 'Our dealer map covers the 50 states and DC.' : coverage && coverage.status === 'unavailable' ? 'Our coverage map didn’t load just now.' : 'Some PO Box and business ZIPs aren’t on our map.';
      html = `<span class="fd-result__icon" aria-hidden="true">?</span><span class="fd-result__text"><strong>We couldn’t place ${zip} on our map.</strong>${why0} We’ll check coverage by hand.</span>`;
      q.textContent = 'Who should we follow up with?';
      why.textContent = 'A person checks your area and calls you back with an answer.';
      aq.textContent = 'Where would the system be installed?';
      awhy.textContent = 'Your street address lets us check coverage by hand.';
    }
    box.innerHTML = html;
    $('[data-fd-zip-echo]').textContent = `· ZIP ${zip}`;
  }

  async function checkZip(allowUnmapped) {
    const raw = field('zip').value.trim();
    const match = raw.match(/^(\d{5})(?:-?\d{4})?$/);
    $('[data-fd-unmapped]').hidden = true;
    if (!match || match[1] === '00000') return setError('zip', 'Enter your 5-digit ZIP code, like 46204.');
    const zip = match[1];
    field('zip').value = zip;
    setError('zip', '');
    const map = await mapReady;
    let result = map && !map.failed ? map.lookup(zip) : { zip, status: 'unavailable' };
    if (result.status === 'unmapped' && !(allowUnmapped && unmappedZip === zip)) {
      unmappedZip = zip;
      setError('zip', `We couldn’t find ${zip} on our map. Double-check it. Some PO Box and business ZIPs aren’t listed.`);
      $('[data-fd-unmapped]').hidden = false;
      return false;
    }
    lead.zip = zip;
    lastAnswered = 'zip';
    const covered = result.status === 'covered', none = result.status === 'none';
    await playLoading([
      `Checking coverage for ${zip}…`,
      covered || none ? 'Looking for Penguin dealers within 30 miles…' : 'Checking our dealer map…',
      covered ? `Found ${plural(result.count, 'dealer area', 'dealer areas')} near you.` : none ? 'Finding your closest dealer…' : 'We’ll need to check this one by hand.'
    ], () => { if (covered || none) result = map.flyToZip(zip); });
    coverage = result;
    fillHidden();
    renderResult();
    showStep('name');
    return true;
  }

  function checkName() {
    const name = field('first_name').value.trim().replace(/\s+/g, ' ');
    if (!name || !/\p{L}/u.test(name)) return setError('first_name', 'Please enter your first name.');
    field('first_name').value = name;
    setError('first_name', '');
    lead.first_name = name;
    showStep('address');
    return true;
  }

  async function checkAddress() {
    const address = field('address').value.trim().replace(/\s+/g, ' ');
    if (!/\d/.test(address) || !/\p{L}{2,}/u.test(address)) return setError('address', 'Please enter your street address, like 123 Main St.');
    field('address').value = address;
    setError('address', '');
    lead.address = address;
    lastAnswered = 'address';
    // Brian asked for this beat to feel like real verification: three lines, ~2.85s in all.
    // The lines describe what the page actually does (a ZIP-level check against the dealer
    // areas); the street itself is confirmed by the dealer, which the next screen says.
    const status = coverage ? coverage.status : 'unavailable';
    const lines = status === 'covered' ? [
      `Adding ${address} to your request…`,
      `Checking ZIP ${lead.zip} against ${plural(coverage.count, 'nearby dealer area', 'nearby dealer areas')}…`,
      `Matching you with the closest dealer, about ${plural(coverage.nearestMiles, 'mile', 'miles')} away…`
    ] : status === 'none' ? [
      `Adding ${address} to your request…`,
      `Checking ZIP ${lead.zip} against Penguin dealer areas…`,
      coverage.nearestMiles != null ? `Noting the closest dealer, about ${plural(coverage.nearestMiles, 'mile', 'miles')} away…` : 'Flagging your request for our dealer team…'
    ] : [
      `Adding ${address} to your request…`,
      `ZIP ${lead.zip} isn’t on our map, so a person will check it…`,
      'Flagging your request for a coverage check by hand…'
    ];
    await playLoading(lines, null, ADDRESS_BEAT_MS / 3);
    renderConfirm();
    showStep('phone');
    return true;
  }

  // Last-step confirmation. Same rule as the ZIP payoff: it says only what the lookup
  // in penguin-area-map-data.json supports, and the no-coverage branches say so plainly.
  function renderConfirm() {
    const box = $('[data-fd-confirm]'), q = $('[data-fd-phone-question]'), label = $('[data-fd-final-label]');
    const status = coverage ? coverage.status : 'unavailable';
    box.className = 'fd-confirm';
    let icon, title, detail;
    if (status === 'covered') {
      box.classList.add('fd-confirm--good');
      icon = '✓';
      title = `Confirmed: a Penguin dealer covers ZIP ${lead.zip}`;
      detail = `${plural(coverage.count, 'dealer area reaches', 'dealer areas reach')} your ZIP. The closest is about ${plural(coverage.nearestMiles, 'mile', 'miles')} away, and they’ll double-check your street when they call.`;
      q.textContent = 'What’s the best number for the dealer to confirm with you?';
      label.textContent = 'Connect me with my dealer';
    } else if (status === 'none') {
      box.classList.add('fd-confirm--none');
      icon = '!';
      title = `No dealer covers ZIP ${lead.zip} yet`;
      detail = coverage.nearestMiles != null ? `We’ll ask the closest one, about ${plural(coverage.nearestMiles, 'mile', 'miles')} away, whether they can travel to you.` : 'We’ll tell you as soon as a dealer covers your area.';
      q.textContent = 'What’s the best number to reach you?';
      label.textContent = 'Send my request';
    } else {
      box.classList.add('fd-confirm--none');
      icon = '?';
      title = `We’ll confirm coverage for ${lead.zip} by hand`;
      detail = 'A person checks which dealer can reach your address and calls you with the answer.';
      q.textContent = 'What’s the best number to reach you?';
      label.textContent = 'Send my request';
    }
    const i = document.createElement('span'); i.className = 'fd-confirm__icon'; i.setAttribute('aria-hidden', 'true'); i.textContent = icon;
    const text = document.createElement('span'); const strong = document.createElement('strong'); strong.textContent = title;
    text.append(strong, detail);
    box.replaceChildren(i, text);
  }

  function phoneDigits(value) {
    let digits = value.replace(/\D/g, '');
    if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
    return digits;
  }
  const formatPhone = d => `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;

  async function checkPhone() {
    const raw = field('phone').value;
    const digits = phoneDigits(raw);
    if (/[a-z]/i.test(raw) || !/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return setError('phone', 'Please enter a 10-digit US phone number, like (317) 555-0147.');
    field('phone').value = formatPhone(digits);
    setError('phone', '');
    const email = field('email').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return setError('email', 'Please enter your email address, like you@example.com.');
    field('email').value = email;
    setError('email', '');
    $('[data-fd-send-failed]').hidden = true;
    lead.phone = field('phone').value;
    lead.email = email;
    lastAnswered = 'phone';
    const covered = coverage && coverage.status === 'covered';
    const sending = send();
    await playLoading([
      'Saving your request…',
      covered ? `Passing it to a Penguin dealer who covers ${lead.zip}…` : 'Passing it to our dealer team…'
    ]);
    const result = await sending;
    if (!result.ok) {
      showStep('phone', { focus: false });
      if (result.field) setError(result.field, result.message);
      else { showSendFailed(sent[sent.length - 1]); $('[data-fd-send-failed]').scrollIntoView({ block: 'nearest' }); }
      return false;
    }
    renderSuccess();
    showStep('success');
    return true;
  }

  function renderSuccess() {
    const covered = coverage && coverage.status === 'covered';
    $('[data-fd-success-title]').textContent = `You’re all set, ${lead.first_name}.`;
    $('[data-fd-success-lead]').textContent = covered
      ? `A Penguin dealer who covers ${lead.zip} will call ${lead.phone} to confirm your address is in their area, usually within one business day.`
      : `We’ll check who can reach ${lead.address} and call ${lead.phone} with an answer, usually within one business day.`;
    const steps = covered
      ? ['Your dealer confirms your address is in their service area.', 'They answer your questions and, if you want, set up a time to test your water.', 'No obligation at any point.']
      : ['We ask the closest dealer whether they can travel to you.', 'If a dealer can’t reach you yet, we’ll tell you as soon as one can.', 'No obligation at any point.'];
    const list = $('[data-fd-next-steps]');
    list.replaceChildren(...steps.map(t => { const li = document.createElement('li'); li.textContent = t; return li; }));
  }

  const handlers = { zip: () => checkZip(false), name: checkName, address: checkAddress, phone: checkPhone };
  let busy = false;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !handlers[current]) return;
    busy = true;
    try { await handlers[current](); } finally { busy = false; }
  });
  $('[data-fd-unmapped-continue]').addEventListener('click', async () => {
    if (busy) return; busy = true;
    try { await checkZip(true); } finally { busy = false; }
  });
  // Editing the ZIP after an "unmapped" warning clears it.
  field('zip').addEventListener('input', () => { $('[data-fd-unmapped]').hidden = true; });
  $('[data-fd-back]').addEventListener('click', () => { if (!busy && backMap[current]) showStep(backMap[current]); });

  // A starting fill so the empty step-1 bar never renders.
  showStep('zip', { focus: false });

  window.__lead = { state: lead, step: () => current, show: name => { if (name === 'name' && !coverage) { renderResult(); } if (name === 'phone') renderConfirm(); if (name === 'success') renderSuccess(); showStep(name); }, sent, get coverage() { return coverage; } };
}
